import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  AppBar, Toolbar, Typography, IconButton, Icon, Hidden,
} from '@material-ui/core';
import UserIcon from './user-icon/user-icon';

import config from '../../../run-config';

const logos = require.context('../../../images/logos', true);

const styles = {
  title: {
    flexGrow: 1,
    marginLeft: '20px',
    fontWeight: '100',
  },
  logoutButton: {
    flexGrow: 0,
  },
  openButton: {
    color: '#ffffff',
  },
  logo: {
    height: '48px',
  },
  dateRange: {
    background: '#dedede',
    color: 'black',
    textAlign: 'center',
  },
};

class Bar extends Component {
  renderDateRange = () => {
    const { dateRange } = this.props;
    const { startDate, endDate } = dateRange;
    const format = 'DD.MM.YYYY HH:mm';
    const sd = moment.unix(startDate).format(format);
    const ed = moment.unix(endDate).format(format);


    return (
      <Hidden smUp>
        <div style={styles.dateRange}>{`${sd} - ${ed}`}</div>
      </Hidden>
    );
  }

  render() {
    const {
      logout, filtersOpen, toggleFiltersOpen, changePassword, userName, useDesktopLayout,
    } = this.props;
    const logo = logos(`./${config.logo}`);

    return (
      <AppBar position="sticky">
        <Toolbar dense disableGutters>
          <div style={styles.open}>
            <IconButton onClick={toggleFiltersOpen} color="inherit">
              <Icon>{filtersOpen ? 'keyboard_arrow_left' : 'menu'}</Icon>
            </IconButton>
          </div>
          <Hidden smDown>
            <img src={logo} style={styles.logo} alt="Logo" />
          </Hidden>
          <Typography variant="h6" style={styles.title}>
            REPORTS
          </Typography>
          {useDesktopLayout && userName}
          <UserIcon
            onLogout={logout}
            changePassword={changePassword}
            loggedIn
          />
        </Toolbar>
        {this.renderDateRange()}
      </AppBar>
    );
  }
}

Bar.propTypes = {
  filtersOpen: PropTypes.bool,
  dateRange: PropTypes.object.isRequired,
  userName: PropTypes.string,
  useDesktopLayout: PropTypes.bool.isRequired,
  changePassword: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  toggleFiltersOpen: PropTypes.func.isRequired,
};

Bar.defaultProps = {
  filtersOpen: true,
  userName: '',
};

export default Bar;
